export default function Machines_B_4 (number = 1) {
  return {
    name: '小型储物仓',
    icon: '/static/img/machines/b4.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_B/Machines_B_4.js